import React from 'react';
import PropTypes from 'prop-types';
import { drawingButtonsHandlers } from '@tcc/treadstone';
import { getMessage } from '@tcc/i18n';
import styles from './MessageBar.css';
import { REGION_SHAPES } from '../../constants/scouting';
import { getRegionMessage } from '../../utils/regionUtils';

function MessageBar({ index, regionMeta, resetState, shape, onDoneClick }) {
  const handleOnCancelClick = () => {
    if (regionMeta[index].isRegionCreated) {
      drawingButtonsHandlers('clear', index);
      const clearIndex =
        index === 1 &&
        document.querySelectorAll('a[title="Clear all layers"]').length > 1
          ? 1
          : 0;
      drawingButtonsHandlers('clearLayers', clearIndex);
    } else {
      const indexForCancel =
        index === 1 &&
        document.querySelectorAll('a[title="Cancel drawing"]').length > 1
          ? 1
          : 0;
      drawingButtonsHandlers('cancel', indexForCancel);
    }
    resetState();
  };

  return (
    (regionMeta[index].isRegionStarted ||
      regionMeta[index].isRegionCreated) && (
      <div
        className={`${styles.drawMessage} ${
          shape === REGION_SHAPES.POLYGON
            ? styles.polygonBackground
            : styles.defaultBackground
        }`}
      >
        <div>
          {getRegionMessage(
            regionMeta[index].isRegionCreated,
            regionMeta[index].isRegionStarted,
            shape,
            regionMeta[index].vertexDrawn
          )}
        </div>
        <div className={styles.drawButtons}>
          <button
            className={`${styles.cancelDraw} ${
              shape === REGION_SHAPES.POLYGON
                ? styles.polygonBackground
                : styles.defaultBackground
            }`}
            onClick={handleOnCancelClick}
            type="button"
          >
            {getMessage('cancel')}
          </button>
          {(regionMeta[index].isRegionCreated ||
            regionMeta[index].vertexDrawn >= 3) && (
            <button
              className={styles.doneDraw}
              disabled={!regionMeta[index].isRegionCreated}
              onClick={onDoneClick}
              type="button"
            >
              {getMessage('done')}
            </button>
          )}
        </div>
      </div>
    )
  );
}

MessageBar.propTypes = {
  index: PropTypes.number.isRequired,
  onDoneClick: PropTypes.func.isRequired,
  regionMeta: PropTypes.array.isRequired,
  resetState: PropTypes.func.isRequired,
  shape: PropTypes.string.isRequired,
};

export default MessageBar;
